/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { actionsStyles } from "@monsma/Overrides/Widgets/QuickOrder/QuickOrderActions";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

actionsStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        clear: both;
        align-items: center;

        ${screen("lte", "sm")} {
            flex-direction: row;
            justify-content: space-between;

            margin-top: 10px;
        }
    `,
};

actionsStyles.overflowMenu = {};

actionsStyles.addAllToCartButton = {
    variant: "primary",
    css: css`
        ${screen("gte", "md")} {
            margin-left: 10px;
        }
    `,
};

actionsStyles.addToListButton = {
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 10px;
                    display: block;
                    width: 100%;
                `,
                css`
                    margin-top: 10px;
                    display: block;
                    width: 100%;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
            ])}
    `,
};

actionsStyles.uploadOrderButton = {
    variant: "secondary",
    css: css`
        &&& {
            ${screen("lte", "sm")} {
                display: block;
                width: 100%;
            }
        }
    `,
};
